import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Automation from "../pages/automation/page";
import Website from "../pages/website/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ai-automation",
    element: <Automation />,
  },
  {
    path: "/website-design",
    element: <Website />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
